<template>
  <div>
    <span
      v-if="value == '#NA#'"
      class="na-grid-cell"
    >
      N/A
    </span>

    <span
      v-else-if="value == '#NREF#'"
      class="nref-grid-cell"
    >⠀</span>

    <span v-else v-html="getValue()"></span>
  </div>
</template>

<script>
export default {
  name: 'DefaultCellRenderer',
  data () {
    return {
      value: ''
    }
  },
  methods: {
    getValue () {
      if (this.value) {
        let vl = this.value
        const founded = this.params.search && vl.toUpperCase().startsWith(this.params.search().toUpperCase())
        if (founded) {
          vl = `<span class='search-highlight'>${this.params.search().toUpperCase()}</span>${this.value.replace(this.params.search().toUpperCase(), '')}`
          return vl
        }
      }
      return this.value
    }
  },
  beforeMount () {
    this.value = ((this.params.data && this.params.column ? this.params.data[this.params.column.colId] === undefined : false) && this.params.nref) ? '#NREF#' : this.params.value
  }
}
</script>

<style scoped>
div {
  width: 100%;
}
span.na-grid-cell,
span.nref-grid-cell {
  display: block;
  text-align: center;
  position: relative;
  z-index: 6;
  margin: 0 auto;
  right: 17px;
  height: 100%;
  width: calc(100% + 17px + 17px);
  font-weight: 700;
}

span.nref-grid-cell {
  background: #2a2a2acb;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/DefaultCellRenderer.vue